import { c as _c } from "react/compiler-runtime";
import { RichContent } from '@openclassrooms/rich-content';
import { styled } from '@classify/react-core-components/styles';
import Stack from '@classify/react-core-components/Stack';
import { imgToNextProxy } from '@openclassrooms/rich-content/services';
import imagesRemotePattern from '@/imagesRemotePattern';
import { useCourseContext } from '../../_contexts/CourseContext';
import LearningOutcomes from './LearningOutcomes';
import Prerequisites from './Prerequisites';
const DescriptionWrapper = styled(RichContent)(({
  theme
}) => ({
  width: '100%',
  overflow: 'hidden',
  [theme.breakpoints.up('md')]: {
    width: 768
  }
}));
const Overview = t0 => {
  const $ = _c(9);
  const {
    introduction
  } = t0;
  const {
    course
  } = useCourseContext();
  const {
    isSinglePage
  } = course;
  let t1;
  if ($[0] !== introduction) {
    t1 = imgToNextProxy(introduction, imagesRemotePattern.map(_temp));
    $[0] = introduction;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const content = t1;
  let t2;
  if ($[2] !== content) {
    t2 = content && <DescriptionWrapper content={content} shouldZoomIntoImage={true} />;
    $[2] = content;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== isSinglePage) {
    t3 = !isSinglePage && <Stack gap={4} sx={{
      marginTop: 8
    }}><LearningOutcomes /><Prerequisites /></Stack>;
    $[4] = isSinglePage;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t2 || $[7] !== t3) {
    t4 = <>{t2}{t3}</>;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  return t4;
};
export default Overview;
function _temp(config) {
  return config.hostname;
}